<div class="layout-container" [class.list-open]="showList">
	<div class="list-section" [class.collapsed]="!showList"
		 [style.width.px]="showList ? listWidth : 36">
		<div class="list-header">
			<button type="button" class="list-collapse-btn"
				(click)="toggleShowList(); $event.stopPropagation()"
				(touchend)="toggleShowList(); $event.stopPropagation(); $event.preventDefault()"
				[title]="showList ? 'Liste schließen' : 'Liste öffnen'">
				<i class="bi" [class.bi-chevron-right]="!showList" [class.bi-chevron-left]="showList"></i>
			</button>
		</div>
		@if (showList) {
			<div class="list-body">
				<div class="list-panel" [style.width.px]="listWidth">
					<ng-content select="[list-element]"></ng-content>
				</div>
			</div>
		} @else if (label) {
			<span class="list-tab-label"
				(click)="toggleShowList()"
				(touchend)="toggleShowList(); $event.preventDefault()">{{ label }}</span>
		}
	</div>
	<div class="content-panel">
		<ng-content select="[content-element]"></ng-content>
	</div>
</div>
